import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
	name: 'money',
})
export class UIMoneyPipe implements PipeTransform {
	constructor(private currency_pipe: CurrencyPipe) {}

	transform(value: number, decimal_places: number = 2, free_when_zero: boolean = false): string {
		if (value !== null && typeof value !== 'undefined') {
			if (free_when_zero && value === 0) {
				return 'FREE';
			} else {
				const return_value = this.currency_pipe.transform(
					value,
					'GBP',
					'symbol',
					'1.' + decimal_places + '-' + decimal_places
				);
				return return_value.charAt(0) === '('
					? '-' + return_value.substring(1, return_value.length - 1)
					: return_value;
			}
		} else {
			return '';
		}
	}
}
